import { Injectable } from '@angular/core';
import {
  Appearance,
  loadStripe,
  Stripe,
  StripeElementLocale,
  StripeElements,
  StripePaymentElement,
  StripeAddressElement,
} from '@stripe/stripe-js';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StripeService {
  private readonly stripePromise: Promise<Stripe | null>;

  stripeElementAppearance: Appearance = {
    theme: 'stripe',
    variables: {
      fontFamily: 'Inter, sans-serif',
      fontSizeBase: '16px',
      fontWeightNormal: '500',
      fontLineHeight: '1.5',
      colorText: '#00162D',
      colorDanger: '#C91D1D',
    },
    // eslint does not allow '.Input:focus' as props
    /* eslint-disable */
    rules: {
      '.Input:focus': {
        borderColor: '#E3E8FF',
      },
      '.Input::placeholder': {
        color: '#fff',
      },
      '.Tab--selected': {
        backgroundColor: '#4361EF',
        color: '#ffffff',
      },
      '.Tab--selected:hover': {
        color: '#ffffff',
      },
    },
    /* eslint-enable */
  };

  stripeLocaleMap: Record<string, StripeElementLocale> = {
    en: 'en',
    de: 'de',
  };

  constructor() {
    this.stripePromise = loadStripe(environment.stripe.publicKey);
  }

  async getStripe() {
    return this.stripePromise;
  }

  async createElements(activeLang: string): Promise<StripeElements | null> {
    const stripe = await this.getStripe();
    return (
      stripe?.elements({
        mode: 'subscription',
        amount: 2050,
        currency: 'eur',
        locale: this.stripeLocaleMap[activeLang],
        appearance: this.stripeElementAppearance,
        fonts: [
          {
            cssSrc:
              'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap',
          },
        ],
      }) ?? null
    );
  }

  // https://docs.stripe.com/payments/payment-element
  createPaymentElement(elements: StripeElements): StripePaymentElement {
    return elements.create('payment', {
      layout: {
        type: 'tabs',
      },
      terms: {
        card: 'never',
      },
    });
  }

  createAddressElement(elements: StripeElements): StripeAddressElement {
    return elements.create('address', {
      mode: 'billing',
      allowedCountries: [
        'AT',
        'BE',
        'BG',
        'CH',
        'CY',
        'CZ',
        'DE',
        'DK',
        'EE',
        'GB',
        'GI',
        'GR',
        'ES',
        'FI',
        'FR',
        'HU',
        'IE',
        'IS',
        'IT',
        'LT',
        'LU',
        'LV',
        'MT',
        'NL',
        'NO',
        'PL',
        'PT',
        'RO',
        'SE',
        'SI',
        'SK',
        'US',
      ],
    });
  }
}
